import { Link, LinkProps } from '@cp/ds/src/components/link';

export const ActivatePromocodeLink = (props: LinkProps) => <Link {...props}>Активировать промокод</Link>;
